export default function isDevelopment() {
  return window.location.origin !== 'https://aurreraathletic.eu';
}